import angular from 'angular'
import template from './template.html'

angular.module('nominas.empresasconceptos')
  .component('nominasEmpresasconceptos', {
    controller: NominasEmpresasconceptosComponent,
    template: template,
    bindings: {
      idProyecto: '<',
    },
  });

function NominasEmpresasconceptosComponent($catalogos, $q, $filter, $location, $state, NominasEmpresasconceptos) {
  let $ctrl = this;
  $ctrl.$onInit = $onInit;
  $ctrl.mostrarTodos = false;
  $ctrl.seleccionarTodo = seleccionarTodo;
  $ctrl.seleccionar = seleccionar;
  $ctrl.obtenerInformacion = obtenerInformacion;
  $ctrl.cancelar = cancelar;
  $ctrl.actualizar = actualizar;
  $ctrl.procesando = false;
  $ctrl.ordenar = 'Descripcion';
  $ctrl.modificado = false;
  $ctrl.error = null;
  $ctrl.filtro = '';

  function $onInit() {
    console.log($ctrl.idProyecto);
    $ctrl.promise = $q.all([
      $catalogos.get('empresas')
        .then(function (data) {
          $ctrl.empresas = data;
        }),
      $ctrl.idProyecto ? NominasEmpresasconceptos.get($ctrl.idProyecto)
        .then(function (response) {
          $ctrl.conceptos = $filter('orderBy')(response.data, ['moneda', 'descripcion']);
        }) : undefined,
    ]);
  }

  function obtenerInformacion() {
    $location.search({id_proyecto: $ctrl.idProyecto});
  }

  function cancelar() {
    $state.reload();
  }

  function actualizar() {
    if ($ctrl.procesando)
      return;

    $ctrl.procesando = true;
    $ctrl.error = null;

    let data = $ctrl.conceptos
      .filter(function (item) {
        return !item.editable || item.activo;
      })
      .map(function (item) {
        return {id_concepto: item.id_concepto};
      });

    return NominasEmpresasconceptos.put($ctrl.idProyecto, data)
      .then(function () {
        $ctrl.data = response.data;
        $ctrl.modificado = false;
      })
      .catch(function (response) {
        $ctrl.error = response.data;
      })
      .finally(function () {
        $ctrl.procesando = false;
      });
  }

  function seleccionar(item) {
    if (!item.editable)
      return;

    item.activo = !item.activo;

    $ctrl.modificado = true;
  }

  function seleccionarTodo(seleccionar) {
    $ctrl.conceptos
      .filter(function (item) {
        return item.editable;
      })
      .forEach(function (item) {
        item.activo = seleccionar;
      });

    $ctrl.modificado = true;
  }
}



// WEBPACK FOOTER //
// ./src/nominas/empresasconceptos/components/component.js